<template>
  <div>
    <app-cells><h1 class="title">List of transfers</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'ProductStorageTransfersLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'product-storage-transfers-active', label: 'Active' },
        { name: 'product-storage-transfers-completed', label: 'Completed' },
      ]
    }
  },
}
</script>
